import type { QueryClient } from "@tanstack/react-query";

import { query } from "@/queries";

/**
 * Account, visit and dossier for this route, in the cache before the page
 * paints. A warm cache returns immediately: an async loader would trip the
 * router's pending minimum and flash a skeleton over data already read.
 */
export function loadVisitDossier(
  queryClient: QueryClient,
  { customerId, visitId }: { customerId: string; visitId: string }
) {
  const detail = query.customers.accountDetail(customerId);
  const visit = query.visits.visit(visitId);
  const dossier = query.visitDossiers.dossier(visitId);
  if (
    queryClient.getQueryData(detail.queryKey) !== undefined &&
    queryClient.getQueryData(visit.queryKey) !== undefined &&
    queryClient.getQueryData(dossier.queryKey) !== undefined
  ) {
    return;
  }
  // `static` reads the cache when it is there and fetches only a miss.
  return Promise.all([
    queryClient.query({ ...detail, staleTime: "static" }),
    queryClient.query({ ...visit, staleTime: "static" }),
    queryClient.query({ ...dossier, staleTime: "static" }),
  ]);
}
